module.exports = __webpack_public_path__ + "img/dongtai.654ed296.gif";